import { getIn } from 'final-form';
import { isConditionalType, } from '../types';
export function evaluateConditions(conditionalFields, allValues) {
    var _a, _b;
    if (isConditionalType(conditionalFields)) {
        var fieldValue = getIn(allValues, conditionalFields.fieldName);
        var isMatched = conditionalFields.comparisonMethod(fieldValue, conditionalFields.fieldName);
        return isMatched;
    }
    if (conditionalFields.logicalOperator === 'AND') {
        return (_a = conditionalFields === null || conditionalFields === void 0 ? void 0 : conditionalFields.conditions) === null || _a === void 0 ? void 0 : _a.every(function (subCondition) {
            return evaluateConditions(subCondition, allValues);
        });
    }
    if (conditionalFields.logicalOperator === 'OR') {
        return (_b = conditionalFields === null || conditionalFields === void 0 ? void 0 : conditionalFields.conditions) === null || _b === void 0 ? void 0 : _b.some(function (subCondition) {
            return evaluateConditions(subCondition, allValues);
        });
    }
    return false;
}
